// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-bg {
  background: linear-gradient(90deg, rgba(255, 242, 242, 0.1) 0%, rgba(153, 145, 145, 0.1) 100%);
}

.gitButton {
  display: flex;
  height: 64px;
  padding: 12px 48px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 950px;
  background: var(--Brand, #FF2459);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: white;
}

.gitButton:hover {
  background: var(--Brand, #af1239);
}

@media screen and (max-width: 650px) {
  .mb_bannerContainer {
    display: flex;
    padding: 36px 24px 0px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  .mb_contentContainer {
    /* height: 225.401px; */
    background: #E5FFF6;
    border-radius: 20px 20px 20px 20px;
  }
  .mb_newPlatformAnnounce {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 8px 25px;
    border-radius: 20px 20px 0px 0px;
    background: #E5FFF6;
  }
  .mb_emoji {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
  .mb_platformText {
    color: #009D64;
    font-family: "General Sans";
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 11.84px;
  }
  .mb_newPlatformContainer {
    display: flex;
    padding: 20px;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
    border-radius: 12px;
    background: #101010;
  }
  .mb_innerContent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
  }
  .mb_textContainer {
    /* width: 556px; */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .mb_heading {
    align-self: stretch;
    color: #FDFDFD;
    font-family: "General Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%;
    text-align: left !important;
  }
  .mb_subheading {
    align-self: stretch;
    color: #878787;
    font-family: "General Sans";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    text-align: left;
  }
  .mb_btn {
    display: flex;
    padding: 8px 24px !important;
    justify-content: center;
    align-items: center;
    font-size: 14px !important;
  }
  .mb_badgeImage {
    width: 96px;
    height: 128px;
    flex-shrink: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/landing-page/components/banner/style.scss"],"names":[],"mappings":"AAAA;EACI,8FAAA;AACJ;;AAMA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,iCAAA;EACA,kDAAA;EACA,YAAA;AAHF;;AAMA;EACE,iCAAA;AAHF;;AAOA;EAEA;IACE,aAAA;IACA,2BAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,SAAA;EALA;EAQF;IACE,uBAAA;IACA,mBAAA;IACA,kCAAA;EANA;EASF;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,SAAA;IACA,iBAAA;IACA,gCAAA;IACA,mBAAA;EAPA;EAUF;IACE,WAAA;IACA,YAAA;IACA,cAAA;EARA;EAWF;IACE,cAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,oBAAA;EATA;EAYF;IACE,aAAA;IACA,aAAA;IACA,mBAAA;IACA,SAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;EAVA;EAaF;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,uBAAA;IACA,SAAA;IACA,WAAA;EAXA;EAcF;IACE,kBAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,QAAA;EAZA;EAeF;IACE,mBAAA;IACA,cAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,2BAAA;EAbA;EAgBF;IACE,mBAAA;IACA,cAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;EAdA;EAiBF;IACE,aAAA;IACA,4BAAA;IACA,uBAAA;IACA,mBAAA;IACA,0BAAA;EAfA;EAmBF;IACE,WAAA;IACA,aAAA;IACA,cAAA;EAjBA;AACF","sourcesContent":[".banner-bg{\n    background: linear-gradient(\n    90deg,\n    rgba(255, 242, 242, 0.1) 0%,\n    rgba(153, 145, 145, 0.1) 100%\n  );\n}\n\n.gitButton{\n  display: flex;\n  height: 64px;\n  padding: 12px 48px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 950px;\n  background: var(--Brand, #FF2459);\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n  color: white;\n}\n\n.gitButton:hover{\n  background: var(--Brand, #af1239);\n  \n}\n\n@media screen and (max-width: 650px) {\n\n.mb_bannerContainer {\n  display: flex;\n  padding: 36px 24px 0px 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.mb_contentContainer {\n  /* height: 225.401px; */\n  background: #E5FFF6;\n  border-radius: 20px 20px 20px 20px;\n}\n\n.mb_newPlatformAnnounce {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 8px 25px;\n  border-radius: 20px 20px 0px 0px;\n  background: #E5FFF6;\n}\n\n.mb_emoji {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.mb_platformText{\n  color: #009D64;\n  font-family: \"General Sans\";\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 11.84px;\n}\n\n.mb_newPlatformContainer{\n  display: flex;\n  padding: 20px;\n  align-items: center;\n  gap: 16px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background:#101010;\n}\n\n.mb_innerContent {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n}\n\n.mb_textContainer {\n  /* width: 556px; */\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.mb_heading {\n  align-self: stretch;\n  color: #FDFDFD;\n  font-family: \"General Sans\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 125%; \n  text-align: left !important;\n}\n\n.mb_subheading {\n  align-self: stretch;\n  color: #878787;\n  font-family: \"General Sans\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 130%; \n  text-align: left;\n}\n\n.mb_btn{\n  display: flex;\n  padding: 8px 24px !important;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px !important;\n  \n}\n\n.mb_badgeImage {\n  width:96px;\n  height:128px;\n  flex-shrink: 0;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
